import {ref} from 'vue';

export default {
    install: (app, options) => {
        const projectClientAssignees = ref([]);

        const urlSearchParams = new URLSearchParams({all: true})
        const loadProjectClientParameters = () => {
            window.lazy_axios.get(`/dashboard/projects/client/parameters?${urlSearchParams.toString()}`)
                .then((response) => {
                    if (response.data.assignees) {
                        projectClientAssignees.value = response.data.assignees;
                    }
                });
        };

        app.provide('projectClientAssignees', projectClientAssignees);
        app.provide('loadProjectClientParameters', loadProjectClientParameters);
    },
}
